import { deactivateHierarchy } from "actions/CarrierAgreementMgmt/Hierarchy";
import { useMutation } from "react-query";

const useDeactivateHierarchies = () => {
  return useMutation(deactivateHierarchy);
};
export default useDeactivateHierarchies;
